import React from 'react';

import api from 'data/api.json';
import contact from 'data/contact.json';

import {
	CallToAction,
	Company,
	CompanyName,
	Container,
	IconContainer,
	Row,
	Text,
	Title
} from './ContactDetails.style';

export function ContactDetails() {
	return (
		<Container>
			<Row>
				<IconContainer>
					<img
						src={`/images/${contact.location.icon.src}`}
						alt={contact.location.icon.alt}
					/>
				</IconContainer>
				<Title>{contact.location.title}</Title>
			</Row>
			<Text>{contact.location.street}</Text>
			<Text>{contact.location.city}</Text>
			<Text>{contact.location.country}</Text>
			<CallToAction href={api.maps} target="_blank" rel="nofollow noreferrer">
				{contact.location.lost}
			</CallToAction>
			<Row>
				<IconContainer>
					<img src={`/images/${contact.phone.icon.src}`} alt={contact.phone.icon.alt} />
				</IconContainer>
				<Title>{contact.phone.title}</Title>
			</Row>
			<Text>{contact.phone.person}</Text>
			<CallToAction href={`tel: ${contact.phone.number}`} rel="nofollow noreferrer">
				{contact.phone.number}
			</CallToAction>
			<Row>
				<IconContainer>
					<img src={`/images/${contact.email.icon.src}`} alt={contact.email.icon.alt} />
				</IconContainer>
				<Title>{contact.email.title}</Title>
			</Row>
			<CallToAction href={`mailto: ${contact.email.address}`} rel="nofollow noreferrer">
				{contact.email.address}
			</CallToAction>
			<Company>
				<CompanyName>Sensix Environment SRL</CompanyName>
				<span>FISCAL CODE</span>
				<p>39129320</p>
				<span>REGISTRY NUMBER</span>
				<p>J35/1092/2018</p>
			</Company>
		</Container>
	);
}
